/*
 * @Author: LZT
 * @Date: 2024-12-10 14:41:41
 * @LastEditors: ITDLCL ZLZ
 * @Description:
 * @FilePath: \qs\src\assets\js\request\index.js
 */
import axios from "axios";
import useUsersStore from "@/stores/user";
import useWindowsStore from "@/stores/windows";

const service = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 50000 // 设置接口超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (!config.data) {
      config.data = {}; // 初始化 config.data 为一个空对象
    };
    config.headers["union_id"] = config.headers["unionid"] = localStorage.getItem("uc_weixin_unionId_qs") || "";
    config.headers["dev_no"] = localStorage.getItem("deviceId") || "";
    if (config.url.includes("prod-web.cloudgn.com")) {
      config.headers["app_src"] = 60; // 走web资讯接口 需要的请求头
    } else {
      const token = localStorage.getItem("token");
      config.headers["Authorization"] = token ? `Bearer ${token}` : '';
    };
    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  // https请求成功回调
  (response) => {
    // 这里可以对响应数据进行处理
    const res = response.data;
    // const code = res?.code || res?.result?.code;
    let code = '';
    if (res?.code || res?.code == 0) {
      code = res.code;
    };
    if (res?.result?.code || res?.result?.code == 0) {
      code = res?.result?.code;
    };
    if (code == 200 || code == 0) {
      return res; // 返回正常的数据
    } else {
      // token过期码处理，跳转到登录页面
      if (code == 401) {
        // const url = window.location.href;
        // const baseUrl = url.split("#")[0];
        // const newUrl = baseUrl + "#/login";
        // window.location.href = newUrl;
        const code = sessionStorage.getItem("code");
        localStorage.clear();
        sessionStorage.clear();
        if (code) {
          sessionStorage.setItem("code", code);
        }
        const usersStore = useUsersStore();
        usersStore.setNewUserInfo({}); // 清空用户信息
        if (response.config?.isLogin && response.config.isLogin == 2) {
          usersStore.setLoginPopup(true);
        }
      } else {
        // 其他错误码处理 以根据需要添加更多的错误处理逻辑
        if (res.msg) {
          console.error(res.msg);
        }
      }
      // 抛出错误，但不会阻止其他请求或应用的运行，只会阻止当前请求的 .then() 链
      // 调用方可以通过 .catch() 捕获错误并继续处理
      return Promise.reject(new Error(res.msg || "请求失败"));
    }
  },
  // https请求失败回调
  (error) => {
    // 响应错误处理 返回一个拒绝的 promise，以便调用者可以捕获这个错误
    return Promise.reject(error);
  }
);

export default service;
